import React, { useState, useEffect, useRef } from "react";
import Draggable from "react-draggable";
import { Stage, Layer, Group } from "react-konva";
import State from "../../components/MachineElement/State.jsx";
import "../Dashboard/Dashboard.css";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import colors from "../../constants/colors";
import { useDot } from "../../context/automatonContext";
import { useLoading } from "../../context/Feedback/loadingContext";
import { useSystem } from "../../context/systemContext";
import Loading from "../../components/Loading/loading";
import { useUser } from "../../context/userContext";
import { organizeArrayToRenderAutomata } from "../../utils/organizeRenderAutomata.js";
import TutorialAutomaton from "../../components/Dialogs/TutorialAutomatonDialog";
import HowToUseGrammarDialog from "components/Dialogs/HowToUseGrammarDialog";
import ImportDot from "../../components/Dialogs/ImportDotDialog";
import constants from "../../constants/automatonLabel";
import constantAlert from "../../constants/Feedback/validationAutomata";
import constantsValidationAutomata from "../../constants/Feedback/validationAutomata";

import { useAlert } from "context/Feedback/alertContext.jsx";
import HistoricalDialog from "components/Dialogs/HistoricalDialog.jsx";
import RegextoAutomatonDialog from "components/Dialogs/RegexToAutomatonDialog.jsx";
import Transition from "components/MachineElement/Transition.jsx";
import SystemOff from "views/System/SystemOff.jsx";
import SimulateAutomataWordDialog from "components/Dialogs/SimulateAutomataWord.jsx";
import DOT from "../../components/MachineElement/DOT";
import SimulationControls from "../../components/SimulationControls/SimulationControls";
import MultiPathSimulator from "../../components/MultiPathSimulator/MultiPathSimulator";

import simulation from "../../views/Simulate/formatList";

import { ExerciseTaskHud } from "components/Exercises";
import { useExerciseTask } from "components/Exercises/hooks/useExerciseTask";

import {
  validateTransition,
  validatePartialTransition,
} from "../../utils/automatonValidator.js";
import automatonInfo from "../../constants/Automaton/automatonInfo.js";
import navbarConstants from "constants/navbarOptions.js";

// Definição de cor necessária para o Konva State
if (!colors.simulationActiveState) {
  colors.simulationActiveState = "#FFD700";
}

// === CONSTANTES DE ZOOM ===
const ZOOM_STEP = 0.1;
const MAX_SCALE = 2.0;
const MIN_SCALE = 0.5;
// ==========================

export default function Dashboard() {
  // eslint-disable-next-line no-unused-vars
  const [_posStars, setStarts] = useState([]);
  let temporaryArray = [];
  const [machineStatePositions, setMachineStatePositions] = useState({});
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  // eslint-disable-next-line no-unused-vars
  const [_numberStates, setNumberStates] = useState(0);
  const [numberElements, setNumberElements] = useState(0);
  const [typeClick, setTypeClick] = useState({
    createState: true,
    connecting: false,
    editState: false,
    editTransition: false,
  });
  const [readyToConect, setReadyToConect] = useState(false);
  const [transition, setTransition] = useState({
    initial: { text: "", xPos: 0, yPos: 0 },
    final: { text: "", xPos: 0, yPos: 0 },
    label: "λ",
  });
  const [currentState, setCurrentState] = useState(null);
  const [currentTransition, setCurrentTransition] = useState(null);
  const [openEditState, setOpenEditState] = useState(false);
  const [openEditTransition, setOpenEditTransition] = useState(false);
  const [startTouch, setStartTouch] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const transitionRefs = useRef([]);
  const [scale, setScale] = useState(1.0); // Escala de zoom para o Dashboard
  const {
    dot,
    setDot,
    setArrayElements,
    setActualMachine,
    childs1,
    setChilds,
    machineStates,
    setMachineStates,
    machineTransitions,
    setMachineTransitions,
    automatonType,
    simulationPath,
    simulationIndex,
    isSimulating,
    setSimulationIndex,
    setIsSimulating,
    setSimulationPath,
    responseSimulate,
    isMultiPathSimulating,
    setIsMultiPathSimulating,
    currentComputationLevel,
    dataTreeDerivation,
  } = useDot();
  const { isAlive } = useSystem();
  const { setAlert, clearAlert } = useAlert();
  const { loading, setLoading } = useLoading();
  const { isAdmin, language, credential } = useUser();

  const [editedText, setEditedText] = useState(currentState?.text || "");
  const [isEditing, setIsEditing] = useState(false);
  const [editedTransitionLabel, setEditedTransitionLabel] = useState("");
  const [partialValidationError, setPartialValidationError] = useState("");
  const queryParams = new URLSearchParams(window.location.search);
  const exerciseTypeFromUrl = queryParams.get("type") || "MACHINE";

  const { currentTask, handleSend, handleCloseTaskHud } = useExerciseTask({
    credential,
    isAdmin,
    language,
    setAlert,
    setLoading,
    defaultType: exerciseTypeFromUrl,
  });

  const getDotData = () => {
    let dotObj = new DOT(machineStates, machineTransitions);
    dotObj.toDotLanguage();
    return dotObj.toString();
  };

  const handleSendExerciseResponse = async (textoDaCaixaHud) => {
    let data = "";
    if (currentTask.type === "REGULAR_EXPRESSIONS") {
      data = textoDaCaixaHud;
    } else {
      data = getDotData();
    }
    const res = await handleSend(data, currentTask.type);
    return res;
  };

  useEffect(() => {
    if (currentState?.text) {
      setEditedText(currentState.text);
    }
  }, [currentState?.text]);

  useEffect(() => {
    if (openEditTransition) {
      clearAlert();

      if (currentTransition) {
        setEditedTransitionLabel(currentTransition.label);
      }
      setPartialValidationError("");
    }
  }, [openEditTransition, currentTransition, clearAlert]);

  useEffect(() => {
    if (openEditState) {
      clearAlert();
    }
  }, [openEditState, clearAlert]);
  /** === FUNÇÕES DE ZOOM === */

  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + ZOOM_STEP, MAX_SCALE));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - ZOOM_STEP, MIN_SCALE));
  };

  const handleZoomReset = () => {
    setScale(1.0);
  };

  /**
   *
   * Atualiza o texto do estado conforme o usuário digita.
   *
   * @param {Object} event - Evento do input de texto.
   *
   */
  const handleTextChange = (event) => {
    setEditedText(event.target.value);
  };

  /**
   *
   * Ativa o modo de edição para alterar o nome do estado.
   *
   */
  const handleEditClick = () => {
    setEditedText(currentState?.text || "");
    setIsEditing(true);
  };

  /**
   *
   * Atualiza o nome e ID do estado atual.
   *
   * @param {string} newName - Novo nome para o estado.
   */

  const changeNameAndIdState = (newName) => {
    if (!currentState) {
      return;
    }

    const updatedStates = machineStates.map((state) => {
      if (state.id === currentState.id) {
        return { ...state, text: newName, id: newName };
      }
      return state;
    });

    setMachineStates(updatedStates);
    setCurrentState((prevState) => ({
      ...prevState,
      text: newName,
      id: newName,
    }));
  };

  /**
   *
   * Atualiza as transições que fazem referência ao estado.
   *
   * @param {string} oldName - Nome anterior do estado.
   * @param {string} newName - Novo nome do estado.
   */

  const updateTransitionsWithState = (oldName, newName) => {
    const updatedTransitions = machineTransitions.map((transition) => {
      if (transition.initial.text === oldName) {
        transition.initial.text = newName;
      }
      if (transition.final.text === oldName) {
        transition.final.text = newName;
      }
      return transition;
    });
    setMachineTransitions(updatedTransitions);
  };

  /**
   *
   * Confirma a alteração do nome do estado atual, verificando validações.
   *
   */
  const handleConfirmClick = () => {
    if (!currentState) {
      return;
    }

    const oldName = currentState.text;

    if (editedText.trim() === "") {
      setEditedText(oldName);
      setAlert({
        active: true,
        text: constantsValidationAutomata.validState.error.emptyName[language],
        color: "warning",
      });
      return;
    }

    if (editedText === oldName) {
      setIsEditing(false);
      clearAlert();
      return;
    }

    if (machineStates.some((state) => state.text === editedText)) {
      setAlert({
        active: true,
        text: constantsValidationAutomata.validState.error.nameInUse[language],
        color: "warning",
      });
      return;
    }

    changeNameAndIdState(editedText);
    updateTransitionsWithState(oldName, editedText);

    clearAlert();

    setCurrentState((prevState) =>
      prevState ? { ...prevState, text: editedText, id: editedText } : null
    );

    setIsEditing(false);
  };

  useEffect(() => {
    document.addEventListener("contextmenu", function (event) {
      event.preventDefault();
    });
    if (getHighestState() == 0) {
      setNumberStates(getHighestState());
    } else {
      setNumberStates(getHighestState() + 1);
    }

    if (dot && dot.length > 0) {
      drawDOTtoAutomaton(dot);
    }
  }, [dot]);

  useEffect(() => {
    if (machineTransitions.length > 0 && automatonType) {
      validateAllTransitions();
    }
  }, [automatonType]);

  const handleClickOpen = (obj) => {
    setCurrentTransition(obj);
    setEditedTransitionLabel(obj.label);
    setPartialValidationError("");
    setOpenEditTransition(true);
    setTimeout(() => {
      let el = document.getElementById("text-transition");
      if (el) {
        el.setSelectionRange(0, el.value.length);
      }
    }, 50);
  };

  /**
   * Fecha o HUD de exercício e simultaneamente encerra qualquer simulação ativa.
   */
  const handleCloseHUDAndSimulation = () => {
    setIsSimulating(false);
    setIsMultiPathSimulating(false);
    setSimulationIndex(0);
    setDot(null);
    setMachineStates([]);
    setMachineTransitions([]);
    setSimulationPath([]);

    handleCloseTaskHud();
  };

  const handleClose = () => {
    clearAlert();

    setOpenEditTransition(false);
    setOpenEditState(false);
    setEditedText("");
    setIsEditing(false);
  };
  const existTransition = (initial, final) => {
    let flag = false;
    for (let t of transitionRefs.current) {
      if (t != null) {
        if (t.props.initial.text == final && t.props.final.text == initial) {
          flag = true;
        }
      }
    }
    return flag;
  };
  const updateTransitions = () => {
    const refs = transitionRefs.current;
    for (let t of refs) {
      if (t != null) {
        const s1 = t.props.initial.text;
        const s2 = t.props.final.text;
        if (existTransition(s1, s2)) {
          t.updateTransitionPosition(true);
        } else {
          t.updateTransitionPosition(false);
        }
      }
    }
  };
  const handleShapeDragEnd = (e, machineState, index) => {
    var shape = e.target;
    const newX = shape.getX();
    const newY = shape.getY();
    let tempState = [...machineStates];
    let obj = tempState[index];
    obj = Object.assign(obj, { x: newX, y: newY });
    tempState.splice(index, 1, obj);
    setMachineStates(tempState);
    for (let t of transitionRefs.current) {
      if (t != null) {
        if (t.props.initial.text == machineState.props.text) {
          t.props.initial.xPos = newX;
          t.props.initial.yPos = newY;
        }
        if (t.props.final.text == machineState.props.text) {
          t.props.final.xPos = newX;
          t.props.final.yPos = newY;
        }
        t.updateTransitionPosition();
      }
    }
  };
  const createState = (x, y) => {
    const tempState = [...machineStates];
    const tempStatePositions = machineStatePositions;

    let tempNumberState = 0;
    while (machineStates.some((state) => state.id === `q${tempNumberState}`)) {
      tempNumberState++;
    }
    tempState.push({
      id: "q" + tempNumberState,
      text: "q" + tempNumberState,
      color: colors.stateColor,
      x: x || mousePosition.x,
      y: y || mousePosition.y,
      isInitial: false,
      isFinal: false,
      visible: true,
    });
    tempStatePositions["q" + tempNumberState] = {
      id: "q" + tempNumberState,
      text: "q" + tempNumberState,
      color: colors.stateColor,
      x: x || mousePosition.x,
      y: y || mousePosition.y,
      isInitial: false,
      isFinal: false,
      visible: true,
    };
    setMachineStatePositions({ ...tempStatePositions });
    setMachineStates(tempState);
    setNumberStates(tempNumberState + 1);
    setNumberElements(numberElements + 1);
  };

  const createTransition = () => {
    let tempState = [...machineTransitions];
    let existeTransicao = false;
    let transitionExist;
    tempState.forEach((obj) => {
      if (
        obj.initial.text == transition.initial.text &&
        obj.final.text == transition.final.text
      ) {
        existeTransicao = true;
        transitionExist = obj;
      }
    });

    const isValid = validateTransition(transition.label, automatonType);
    let newTransition;
    if (isValid) {
      newTransition = {
        initial: transition.initial,
        final: transition.final,
        label: transition.label,
        stroke: "black",
        strokeWidth: 1,
        labelColor: "black",
        labelFontWeight: "normal",
      };
    } else {
      newTransition = {
        initial: transition.initial,
        final: transition.final,
        label: transition.label,
        stroke: "black",
        strokeWidth: 1,
        labelColor: "red",
      };
    }

    if (!existeTransicao) {
      tempState.push(newTransition);
      setMachineTransitions(tempState);
      handleClickOpen(newTransition);
    } else {
      const index = machineTransitions.indexOf(transitionExist);
      transitionExist.stroke = "black";
      transitionExist.strokeWidth = 1;
      transitionExist.labelColor = "red";
      tempState.splice(index, 1, transitionExist);
      setMachineTransitions(tempState);

      setTimeout(() => {
        transitionExist.stroke = "black";
        transitionExist.strokeWidth = 1;
        transitionExist.labelColor = "black";
        tempState.splice(index, 1, transitionExist);
        setMachineTransitions(tempState);
      }, 500);
    }
  };

  const selectEelement = (e) => {
    let comparator;
    if (e.target.attrs.id != undefined) {
      comparator = e.target.attrs.id;
    } else if (e.target.attrs.text != undefined) {
      comparator = e.target.attrs.text;
    }
    const element = machineStates.filter(
      (obj) => obj != null && obj.id == comparator
    )[0];
    return element;
  };

  const changeStateColor = (id, color) => {
    const fakeElement = {
      target: {
        attrs: {
          id: id,
        },
      },
    };
    let initialState = selectEelement(fakeElement);
    initialState.color = color;
  };

  const handleClickState = (e, stateKonva) => {
    const button = e.evt.button;
    let state = selectEelement(e);
    if (state == undefined) {
      const fakeElement = {
        target: {
          attrs: {
            id: stateKonva.props.text,
          },
        },
      };
      state = selectEelement(fakeElement);
    }
    let transitionTemp = transition;
    if (button == 0) {
      if (readyToConect) {
        const final = {
          text: state.text,
          xPos: state.x,
          yPos: state.y,
        };
        transitionTemp.final = final;

        changeStateColor(transition.initial.text, colors.stateColor);
        setTransition(transitionTemp);
        setReadyToConect(false);
        setCurrentState({});
        createTransition();
      } else {
        state.color = colors.grayishGreen;
        const initial = {
          text: state.text,
          xPos: state.x,
          yPos: state.y,
        };
        transitionTemp.initial = initial;
        setReadyToConect(true);
        setCurrentState(state);
        setTransition(transitionTemp);
      }
    } else if (button == 2) {
      let state = selectEelement(e);
      state.color = colors.stateColor;
      setCurrentState(state);
      setOpenEditState(true);
      setReadyToConect(false);
    }
  };

  const handleClick = (e) => {
    const button = e.evt.button;
    const isTouch = e.evt.type === "touchend" ? true : false;

    const { x, y } = e.currentTarget.getPointerPosition();

    if (button === 0 || isTouch) {
      if (e.target === e.currentTarget) {
        if (readyToConect) {
          changeStateColor(transition.initial.text, colors.stateColor);
          setReadyToConect(false);
          setCurrentState({});
        } else {
          createState(x, y);
        }
      }
    }
  };

  const handleMouseMove = (e) => {
    const pos = {
      x: e.evt.layerX,
      y: e.evt.layerY,
    };
    setMousePosition(pos);
  };

  const handleChangeLabelTransition = (e) => {
    const newLabel = e.target.value.replace(".", "λ");
    const isValidPartially = validatePartialTransition(newLabel, automatonType);
    if (isValidPartially) {
      setEditedTransitionLabel(newLabel);
      setPartialValidationError("");
    } else {
      setPartialValidationError(
        `${automatonInfo.transition.error.invalid[language]} ${navbarConstants.automatonSelector.machineTypes[automatonType][language]}. ${automatonInfo.transition.error.example[language]} ${automatonInfo.transition.error.transitionExample[language][automatonType]}`
      );
    }
  };
  /**
   * Limpa e formata o rótulo da transição.
   * - Remove espaços no início.
   * - Remove espaços entre as vírgulas.
   * - Remove vírgulas no final seguidas de espaços.
   * - Remove espaços ao redor da barra (/).
   * - Substitui múltiplos espaços por um único.
   * @param {string} label O rótulo da transição a ser limpo.
   * @returns {string} O rótulo da transição formatado.
   */
  const cleanTransitionLabel = (label) => {
    let cleanedLabel = label;
    cleanedLabel = cleanedLabel.replace(/\s*,\s*/g, ",");
    cleanedLabel = cleanedLabel.replace(/,(\s*)/g, ",");
    cleanedLabel = cleanedLabel.replace(/,\s*$/g, "");
    cleanedLabel = cleanedLabel.replace(/\s*\/\s*/g, "/");
    cleanedLabel = cleanedLabel.replace(/\s{2,}/g, " ");
    return cleanedLabel;
  };

  const validateAllTransitions = () => {
    const updatedTransitions = machineTransitions.map((transition) => {
      if (validateTransition(transition.label, automatonType)) {
        return {
          ...transition,
          stroke: "black",
          strokeWidth: 1,
          labelColor: "black",
        };
      } else {
        return {
          ...transition,
          stroke: "black",
          strokeWidth: 1,
          labelColor: "red",
        };
      }
    });
    setMachineTransitions(updatedTransitions);
  };

  const handleConfirmTransitionEdit = () => {
    const finalLabel = cleanTransitionLabel(editedTransitionLabel);

    const transitionIndex = machineTransitions.findIndex(
      (t) =>
        t.initial.text === currentTransition.initial.text &&
        t.final.text === currentTransition.final.text &&
        (t === currentTransition || t.label === currentTransition.label)
    );

    if (transitionIndex === -1) {
      handleClose();
      return;
    }

    let updatedTransition = { ...machineTransitions[transitionIndex] };
    updatedTransition.label = finalLabel;

    if (validateTransition(finalLabel, automatonType)) {
      updatedTransition.stroke = "black";
      updatedTransition.strokeWidth = 1;
      updatedTransition.labelColor = "black";

      setPartialValidationError("");

      let tempState = [...machineTransitions];
      tempState.splice(transitionIndex, 1, updatedTransition);
      setMachineTransitions(tempState);

      handleClose();
    } else {
      setAlert({
        active: true,
        text: `${automatonInfo.transition.error.invalid[language]} ${navbarConstants.automatonSelector.machineTypes[automatonType][language]}. ${automatonInfo.transition.error.example[language]} ${automatonInfo.transition.error.transitionExample[language][automatonType]}`,
        color: "warning",
        severity: "error",
        duration: 5000,
      });
    }
  };

  const changeTypeState = (type) => {
    let tempState = [...machineStates];
    const index = machineStates.indexOf(currentState);

    if (type.includes("isInitial")) {
      const oldInitialState = tempState.find(
        (state) => state.isInitial && state.id !== currentState.id
      );

      if (oldInitialState) {
        const oldIndex = tempState.findIndex(
          (state) => state.id === oldInitialState.id
        );
        tempState[oldIndex] = { ...oldInitialState, isInitial: false };
      }
    }
    if (type.includes("+")) {
      if (currentState["isInitial"] && currentState["isFinal"]) {
        currentState["isInitial"] = false;
        currentState["isFinal"] = false;
      } else {
        currentState["isInitial"] = true;
        currentState["isFinal"] = true;
      }
    } else {
      if (currentState["isInitial"] && type == "isFinal") {
        currentState["isInitial"] = false;
        currentState["isFinal"] = true;
      } else if (currentState["isFinal"] && type == "isInitial") {
        currentState["isFinal"] = false;
        currentState["isInitial"] = true;
      } else {
        currentState[type] = !currentState[type];
      }
    }
    tempState.splice(index, 1, currentState);
    setMachineStates(tempState);
    handleClose();
  };

  const handleDeleteTransition = () => {
    let tempTransition = [...machineTransitions];
    const index = tempTransition.indexOf(currentTransition);
    if (index !== -1) {
      tempTransition.splice(index, 1);
      setMachineTransitions(tempTransition);

      let dot = new DOT(machineStates, tempTransition);
      dot.toDotLanguage();
      setDot(dot.toString());
    }
    handleClose();
    validateAllTransitions();
  };

  const handleDeleteState = () => {
    let tempState = [...machineStates];
    let tempTransitions = [...machineTransitions];
    const index = tempState.indexOf(currentState);
    tempState.splice(index, 1);
    let statesDeleted = [];
    for (let i = 0; i < tempTransitions.length; i++) {
      const el = tempTransitions[i];
      if (el.initial.text == currentState.text) {
        el.vis = false;
        statesDeleted.push(el.initial.text);
      }
      if (el.final.text == currentState.text) {
        el.vis = false;
        statesDeleted.push(el.final.text);
      }
    }
    let array = tempTransitions.filter((el) => el.vis != false);

    setMachineStates(tempState);
    setMachineTransitions(array);
    updateTransitions();
    handleClose();
  };

  /**
   * Converte uma string DOT em elementos de autômato para renderização.
   *
   * @param {string} dot - A string no formato DOT.
   */
  const drawDOTtoAutomaton = (dot) => {
    try {
      setMachineTransitions([]);

      let highestState = 0;
      setScreenWidth(window.innerWidth);
      const arrayRender = organizeArrayToRenderAutomata(dot);
      for (let i = 0; i < arrayRender.states.length; i++) {
        const state = arrayRender.states[i];
        const numberState = parseInt(state.text.split("q")[1], 10);
        if (state.x > screenWidth) {
          setScreenWidth(state.x + 50);
        }
        if (state.y > screenHeight) {
          setScreenHeight(state.y + 50);
        }
        if (numberState > highestState) {
          highestState = numberState;
        }
      }
      setMachineStates(arrayRender.states);
      const validatedTransitions = arrayRender.transitions.map((transition) => {
        if (validateTransition(transition.label, automatonType)) {
          return {
            ...transition,
            stroke: "black",
            strokeWidth: 1,
            labelColor: "black",
          };
        } else {
          return {
            ...transition,
            stroke: "black",
            strokeWidth: 1,
            labelColor: "red",
          };
        }
      });

      setTimeout(() => {
        setMachineTransitions(validatedTransitions);
      }, 0);

      setActualMachine(temporaryArray);
      setNumberStates(highestState + 1);
      setArrayElements(childs1);
    } catch (e) {
      setDot("");
      setAlert({
        active: true,
        text: constantAlert.invalidFormat[language],
        color: "warning",
        sevarity: "error",
      });
    }
  };
  const handleStateTouch = (e) => {
    if (!typeClick.connecting) {
      let state = selectEelement(e);

      const typeClick = {
        createState: true,
        connecting: true,
        editState: false,
        editTransition: false,
      };

      setTypeClick(typeClick);

      if (state != undefined) {
        setTransition(
          Object.assign(transition, {
            initial: {
              text: state.text,
              xPos: state.x,
              yPos: state.y,
            },
          })
        );
        state = Object.assign(state, { color: colors.grayishGreen });
        let machineStateTemp = [...machineStates];
        const index = machineStateTemp.indexOf(state);

        machineStateTemp.splice(index, 1, state);
        setMachineStates(machineStateTemp);
      }
    } else if (typeClick.connecting) {
      const state = selectEelement(e);
      if (state != undefined) {
        setTransition(
          Object.assign(transition, {
            final: {
              text: state.text,
              xPos: state.x,
              yPos: state.y,
            },
          })
        );
      }

      const typeClick = {
        createState: true,
        connecting: false,
        editState: false,
        editTransition: false,
      };
      const fakeElement = {
        target: {
          attrs: {
            id: transition.initial.text,
          },
        },
      };

      let initialState = selectEelement(fakeElement);
      initialState = Object.assign(initialState, {
        color: colors.stateColor,
      });
      let machineStateTemp = [...machineStates];
      const index = machineStateTemp.indexOf(initialState);

      machineStateTemp.splice(index, 1, initialState);
      setMachineStates(machineStateTemp);

      setTypeClick(typeClick);
      createTransition();
    }
  };
  const touchEditState = (e) => {
    if (new Date().getTime() - startTouch > 300) {
      const state = selectEelement(e);
      setCurrentState(state);
      setOpenEditState(true);
    }
  };
  const getHighestState = () => {
    let highestState = 0;
    for (let state of machineStates) {
      const numberState = parseInt(state.text.split("q")[1], 10);
      if (numberState > highestState) {
        highestState = numberState;
      }
    }
    return highestState;
  };

  const displayText = (text) => {
    if (!text) {
      return "";
    }
    const maxNameLength = 12;
    if (text.length > maxNameLength) {
      return text.substring(0, maxNameLength - 3) + "...";
    } else {
      return text;
    }
  };

  /**
   * Obtém o nome do estado atual com base no índice de simulação.
   *
   * @returns {string | null} O nome do estado atual (e.g., "q0").
   */
  const currentSimulationStateName = isSimulating
    ? simulationPath[simulationIndex]
    : null;

  /**
   * Avança um passo na simulação.
   */
  const handleNextStep = () => {
    if (simulationIndex < simulationPath.length - 1) {
      setSimulationIndex(simulationIndex + 1);
    } else {
      setAlert({
        active: true,
        text: "Simulação concluída. Você está no último passo.",
        color: "info",
        severity: "info",
      });
    }
  };

  /**
   * Volta um passo na simulação.
   */
  const handlePreviousStep = () => {
    if (simulationIndex > 0) {
      setSimulationIndex(simulationIndex - 1);
    }
  };

  /**
   * Encerra a simulação visual e reseta os estados de controle.
   */
  const handleStopSimulating = () => {
    setIsSimulating(false);
    setSimulationIndex(0);
    setSimulationPath([]);
  };

  // Determinação do Passo Final
  const isFinalStep = simulationIndex === simulationPath.length - 1;

  const activeStatesMultiPath = isMultiPathSimulating
    ? simulation
        .getStepsByLevel(dataTreeDerivation, currentComputationLevel)
        .map((step) => step.name)
    : [];

  if (!isAlive && !isAdmin) {
    return <SystemOff />;
  }

  transitionRefs.current = [];

  return (
    <div>
      <Loading loading={loading} />

      {isSimulating && !isMultiPathSimulating && (
        <SimulationControls
          simulationPath={simulationPath}
          simulationIndex={simulationIndex}
          isFinalStep={isFinalStep}
          currentSimulationStateName={currentSimulationStateName}
          responseSimulate={responseSimulate}
          language={language}
          machineStates={machineStates}
          machineTransitions={machineTransitions}
          handleNextStep={handleNextStep}
          handlePreviousStep={handlePreviousStep}
          handleStopSimulating={handleStopSimulating}
          setSimulationIndex={setSimulationIndex}
          setIsSimulating={setIsSimulating}
          setSimulationPath={setSimulationPath}
          setAlert={setAlert}
        />
      )}

      {isMultiPathSimulating && <MultiPathSimulator />}

      <div>
        <Dialog
          open={openEditTransition}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          onKeyUp={(e) => {
            const ENTER = 13;
            if (e.keyCode === ENTER) {
              handleConfirmTransitionEdit();
            }
          }}
        >
          <DialogTitle id="form-dialog-title">
            <div className="wrapper-title">
              {(currentTransition != null &&
                `${constants.dialog.transition[language]} ${
                  currentTransition.initial.text || ""
                } → ${currentTransition.final.text || ""}`) ||
                ""}
              <div
                className="wrapper-button-close button-margin"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  style={{ backgroundColor: "#999", color: "#FFF" }}
                  onClick={handleClose}
                >
                  X
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <TextField
              id="text-transition"
              name="transition_input"
              label={constants.dialog.transition[language]}
              autoComplete="off"
              autoFocus
              margin="dense"
              value={editedTransitionLabel}
              onChange={(e) => {
                handleChangeLabelTransition(e);
              }}
              type="text"
              fullWidth
            />
            {partialValidationError && (
              <p style={{ color: "red", marginTop: "8px" }}>
                {partialValidationError}
              </p>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "black" }}
              onClick={handleConfirmTransitionEdit}
            >
              OK
            </Button>
            <Button onClick={handleDeleteTransition} color="secondary">
              {constants.dialog.delete[language]}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openEditState}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            <div
              className="wrapper-title"
              style={{
                width: "400px",
                height: "35px",
              }}
            >
              {constants.dialog.state[language]}:
              {isEditing ? (
                <TextField
                  id="edit_state_name"
                  name="edit_state_name"
                  value={editedText}
                  onChange={handleTextChange}
                  autoFocus
                  onFocus={(e) => e.target.select()}
                  placeholder={`${currentState?.text || ""}`}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleConfirmClick();
                    }
                  }}
                  variant="outlined"
                  size="small"
                  className="edit-text-field"
                  style={{
                    margin: "0 8px",
                    width: "35 px",
                    paddingLeft: "8px",
                  }}
                  inputProps={{
                    "aria-label": constants.dialog.state[language],
                    style: { textAlign: "center" },
                  }}
                />
              ) : (
                <span
                  style={{
                    margin: "0 8px",
                    width: "35 px",
                    paddingLeft: "8px",
                  }}
                >
                  {displayText(currentState?.text)}
                </span>
              )}
              <div
                className="wrapper-buttons"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {isEditing ? (
                  <Button
                    style={{
                      backgroundColor: "#4CAF50",
                      color: "#FFF",
                      marginRight: "8px",
                    }}
                    onClick={handleConfirmClick}
                  >
                    <span>&#10003;</span>
                  </Button>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#007BFF",
                      color: "#FFF",
                      marginRight: "8px",
                    }}
                    onClick={handleEditClick}
                  >
                    <EditIcon style={{ color: "#FFF" }} />
                  </Button>
                )}
                <Button
                  style={{ backgroundColor: "#999", color: "#FFF" }}
                  onClick={handleClose}
                >
                  X
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogActions>
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  id="isInitial"
                  style={{
                    color: "black",
                    backgroundColor:
                      currentState != null &&
                      currentState.isInitial &&
                      !currentState.isFinal
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isInitial");
                  }}
                >
                  {constants.dialog.initial[language]}
                </Button>
                <Button
                  id="isFinal"
                  style={{
                    color: "black",
                    backgroundColor:
                      currentState != null &&
                      currentState.isFinal &&
                      !currentState.isInitial
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isFinal");
                  }}
                >
                  {constants.dialog.final[language]}
                </Button>
                <Button
                  id="isInitial+isFinal"
                  style={{
                    color: "black",
                    backgroundColor:
                      currentState != null &&
                      currentState.isFinal &&
                      currentState.isInitial
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isInitial+isFinal");
                  }}
                >
                  {constants.dialog.initialAndfinal[language]}
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "10px",
                }}
              >
                <Button
                  onClick={handleDeleteState}
                  color="secondary"
                  style={{ backgroundColor: colors.redLight }}
                  fullWidth
                >
                  {constants.dialog.delete[language]}
                </Button>
              </div>
            </div>
          </DialogActions>
        </Dialog>
        <TutorialAutomaton />
        <ImportDot setStars={setStarts} setChilds={setChilds} />
        <RegextoAutomatonDialog setStars={setStarts} setChilds={setChilds} />
        <HistoricalDialog setStars={setStarts} setChilds={setChilds} />
        <SimulateAutomataWordDialog
          setStars={setStarts}
          setChilds={setChilds}
        />

        <HowToUseGrammarDialog />

        <div className="response-area">
          <div
            className="stage"
            style={{
              position: "relative",
              width: "100%",
              minHeight: "80vh",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              boxShadow: "inset 0px 8px 20px rgba(0, 0, 0, 0.15)",
              overflow: "auto !important",
            }}
          >
            {/* --- HUD DE EXERCÍCIO --- */}
            {currentTask && (
              <Draggable bounds="parent">
                <div
                  style={{
                    position: "absolute",
                    zIndex: 9999,
                    top: 50,
                    left: 50,
                  }}
                >
                  <ExerciseTaskHud
                    task={currentTask}
                    onSend={handleSendExerciseResponse}
                    onClose={handleCloseHUDAndSimulation}
                    language={language}
                  />
                </div>
              </Draggable>
            )}

            {/* CONTROLES DE ZOOM */}
            <div
              style={{
                position: "absolute",
                top: "30px",
                right: "10px",
                zIndex: 100,
              }}
            >
              <Button
                variant="contained"
                color="default"
                onClick={handleZoomOut}
                disabled={scale <= MIN_SCALE}
                style={{ minWidth: "40px", padding: "6px" }}
              >
                -
              </Button>
              <Button
                variant="outlined"
                color="default"
                onClick={handleZoomReset}
                style={{ margin: "0 5px", minWidth: "40px", padding: "6px" }}
              >
                {Math.round(scale * 100)}%
              </Button>

              <Button
                variant="contained"
                color="default"
                onClick={handleZoomIn}
                disabled={scale >= MAX_SCALE}
                style={{ minWidth: "40px", padding: "6px" }}
              >
                +
              </Button>
            </div>

            <Stage
              style={{ overflow: "auto" }}
              width={screenWidth}
              height={screenHeight}
              // Aplica a escala para o zoom
              scaleX={scale}
              scaleY={scale}
              onClick={
                isSimulating || isMultiPathSimulating ? null : handleClick
              }
              onTap={isSimulating || isMultiPathSimulating ? null : handleClick}
              onMouseMove={handleMouseMove}
              onContextMenu={(e) => {
                e.evt.preventDefault();
              }}
            >
              <Layer>
                <Group id="group-elements">
                  {machineTransitions.map((obj, index) => {
                    const transitionKey = `${obj.initial.text}-${obj.final.text}-${obj.label}-${index}`;

                    return (
                      <Transition
                        key={transitionKey}
                        initial={obj.initial}
                        final={obj.final}
                        label={obj.label}
                        stroke={obj.stroke}
                        strokeWidth={obj.strokeWidth}
                        labelColor={obj.labelColor}
                        onClick={
                          isSimulating || isMultiPathSimulating
                            ? () => {}
                            : () => {
                                handleClickOpen(obj);
                              }
                        }
                        onTap={
                          isSimulating || isMultiPathSimulating
                            ? () => {}
                            : () => {
                                handleClickOpen(obj);
                              }
                        }
                        ref={(iam) => {
                          if (iam) {
                            transitionRefs.current.push(iam);
                          }
                        }}
                      />
                    );
                  })}
                  {machineStates.map((obj, index) => (
                    <State
                      id={obj.id}
                      key={obj.id}
                      x={obj.x}
                      y={obj.y}
                      // LÓGICA DE COLORAÇÃO DO ESTADO ATIVO
                      color={
                        isMultiPathSimulating &&
                        activeStatesMultiPath.includes(obj.text)
                          ? colors.simulationActiveState
                          : isSimulating &&
                              obj.text === currentSimulationStateName
                            ? colors.simulationActiveState
                            : obj.color != undefined
                              ? obj.color
                              : "#e9eaea"
                      }
                      text={obj.text}
                      isInitial={obj.isInitial}
                      isFinal={obj.isFinal}
                      draggable={!isSimulating && !isMultiPathSimulating} // Desativar arraste em qualquer modo de simulação
                      visible={obj.visible}
                      onClick={
                        isSimulating || isMultiPathSimulating
                          ? () => {}
                          : (e, element) => {
                              handleClickState(e, element);
                            }
                      }
                      onDragEnd={(e, element) => {
                        handleShapeDragEnd(e, element, index);
                      }}
                      onTap={
                        isSimulating || isMultiPathSimulating
                          ? () => {}
                          : (e, element) => {
                              handleStateTouch(e, element);
                            }
                      }
                      onTouchStart={() => {
                        setStartTouch(new Date().getTime());
                      }}
                      onTouchEnd={
                        isSimulating || isMultiPathSimulating
                          ? () => {}
                          : (e, element) => {
                              touchEditState(e, element);
                            }
                      }
                    />
                  ))}
                </Group>
              </Layer>
            </Stage>
          </div>
        </div>
      </div>
    </div>
  );
}
